import { createContext, useContext } from 'react'
import type { ReplayFrame } from '@racedash/shared'

/**
 * The replay on screen, shared with every hook that reads for itself.
 *
 * Apart from replay.ts so that the hooks it reaches into can ask for it
 * without importing the loader that imports them.
 */
export interface Replay {
  sessionId: string
  at: Date
  frame: ReplayFrame
}

export const ReplayContext = createContext<Replay | null>(null)

/** The replay on screen, or null when the dashboard is live. */
export function useReplay(): Replay | null {
  return useContext(ReplayContext)
}

/** The replay of this session, if one is on — a screen may be showing another. */
export function useReplayOf(sessionId: string | null): Replay | null {
  const replay = useReplay()
  return replay && sessionId && replay.sessionId === sessionId ? replay : null
}

